import type { PatientWorkspaceTab } from '@/features/patient-workspace';
import { SkeletonTextBlock } from '@/shared/ui/primitives';

interface PatientContentOutletProps {
  /** Currently active view tab */
  activeTab?: string;
  /** Available tabs (including rendered content) */
  tabs: PatientWorkspaceTab[];
}

function PlaceholderContent() {
  return (
    <div className="max-w-xl p-4">
      <SkeletonTextBlock lines={6} />
    </div>
  );
}

/**
 * PatientContentOutlet — scrollable content area for the patient panel.
 */
export function PatientContentOutlet({ activeTab = '', tabs }: PatientContentOutletProps) {
  const active = tabs.find((t) => t.id === activeTab);

  return (
    <div className="h-full overflow-auto p-4 pb-[var(--overlay-dock-inset,16px)]">
      {active?.content ?? <PlaceholderContent />}
    </div>
  );
}
